import { NcrType, ReferralType } from '../../constants.js'
import isEmpty from '../../utility/isEmpty'

export default {
  /**
   * Gets the referral URL from stored customer info.
   * @param {Object} state - The current Vuex customer state values
   * @returns {String} The BirdEye referral URL.
   */
  getReferralUrl (state) {
    return !isEmpty(state.referralInfo) ? state.referralInfo.url : undefined
  },

  /**
   * Determines if customer is allowed to enroll in Referral Rewards. No need to check Retail feature flag (displayRetailReferral), since this is only used for non customers.
   *  1. Don't allow if feature flag is off (takes into account top level flag as well)
   *  2. Don't allow if cognito attribute for NCR is 'customer'
   *  3. Don't allow if connected to NLS loan
   */
  canEnrollInReferralRewards (state, getters, rootState, rootGetters) {
    const referralEnabledNCR = !isEmpty(rootState.session.displayNonCustomerReferral) ? rootState.session.displayNonCustomerReferral : false
    const isEnrolledInReferralProgram = isEmpty(state.ncrCognitoAttribute) ? false : state.ncrCognitoAttribute === NcrType.customer
    const isNonCustomer = rootGetters['customer/isNonCustomer']
    const isNlsUser = rootGetters['customer/isNlsUser']
    return referralEnabledNCR && !isEnrolledInReferralProgram && !isNlsUser && isNonCustomer
  },

  /**
   * Determines if customer is enrolled in Referral Rewards
   */
  isReferralRewardsUser (state, getters, rootState, rootGetters) {
    return getReferralInfo(state, getters, rootState, rootGetters).isRewardsUser
  },

  /**
   * Determines if customer is ECR
   */
  isEcrUser (state, getters, rootState, rootGetters) {
    return getReferralInfo(state, getters, rootState, rootGetters).referralType === ReferralType.ecr
  }
}

const getReferralInfo = (state, getters, rootState, rootGetters) => {
  const referralEnabledNCR = !isEmpty(rootState.session.displayNonCustomerReferral) ? rootState.session.displayNonCustomerReferral : false
  const referralEnabledRetail = !isEmpty(rootState.session.displayRetailReferral) ? rootState.session.displayRetailReferral : false

  if (!referralEnabledNCR && !referralEnabledRetail) {
    return { isRewardsUser: false, referralType: ReferralType.none }
  }
  if (rootGetters['customer/isTlxeUser']) {
    return { isRewardsUser: referralEnabledRetail, referralType: ReferralType.ecr } // If retail customer use retail feature flag
  }
  if (!rootGetters['customer/isNlsUser'] && !isEmpty(state.ncrCognitoAttribute) ? state.ncrCognitoAttribute === NcrType.customer : false) {
    return { isRewardsUser: referralEnabledNCR, referralType: ReferralType.ncr } // If non-customer use non-customer feature flag
  }
  return { isRewardsUser: false, referralType: ReferralType.none } // If you are not a non-customer or retail customer (either nothing linked or NLS only), disable referral
}
